import { FC } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { BroadcastNotifications } from './broadcastNotifications/BroadcastNotifications';
import { BroadcastTab } from './constants';
import { PublishedNotifications } from './publishedNotifications/PublishedNotifications';

import css from './BroadcastNotificationsPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';

export const BroadcastNotificationsPage: FC = () => {
  const { activeTab, onTabChange } = useTabs<BroadcastTab>(BroadcastTab.CREATE);

  const handleTabChange = (_: unknown, tab: BroadcastTab) => {
    onTabChange(tab);
  };

  const handleCreateSuccess = () => {
    onTabChange(BroadcastTab.PUBLISHED);
  };

  return (
    <PageLayout className={css.page} overflow="hidden">
      <PageTitle>Notifications</PageTitle>

      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab value={BroadcastTab.CREATE} label="Create" />
        <Tab value={BroadcastTab.PUBLISHED} label="Published" />
      </Tabs>

      <div className={css.content}>
        {activeTab === BroadcastTab.CREATE && <BroadcastNotifications onSuccess={handleCreateSuccess} />}
        {activeTab === BroadcastTab.PUBLISHED && <PublishedNotifications />}
      </div>
    </PageLayout>
  );
};
